"use client";

import {  useState } from 'react';
import { mediaUrl, ReferralData } from './referralData';
import ReferralModal from './dashboard/components/ReferralModal';


function ReferrerIllustration() {
  return (
    <svg
      className="absolute right-4 sm:h-16 sm:w-16 sm:bottom-1 bottom-4 md:right-7 md:bottom-6 opacity-[0.08]"
      width="160"
      height="150"
      viewBox="0 0 160 150"
      fill="none"
    >
      {/* thumbs up (top-left) */}
      <rect x="6" y="40" width="16" height="34" rx="3" fill="#002662" />
      <path
        d="M24 46h6c4 0 7-2 8-6l4-12c1-3 4-5 7-4 3 1 4 4 4 7l-2 11h13c4 0 7 3 6 7l-5 18c-1 4-4 6-8 6H24V46z"
        fill="#002662"
      />

      {/* arrow right (thumbs -> person) */}
      <path d="M82 50h18" stroke="#002662" strokeWidth="6" strokeLinecap="round" />
      <path
        d="M94 42l9 8-9 8"
        stroke="#002662"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* person (top-right) */}
      <circle cx="130" cy="42" r="15" fill="#002662" />
      <path
        d="M114 84c0-9 7-16 16-16s16 7 16 16v5h-32v-5z"
        fill="#002662"
      />

      {/* arrow down on right (person -> reward) */}
      <path
        d="M138 96v18h-26"
        stroke="#002662"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M120 105l-9 9 9 9"
        stroke="#002662"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* rupee reward circle (bottom) */}
      <circle cx="78" cy="114" r="19" stroke="#002662" strokeWidth="6" />
      <path
        d="M71 105h14M71 112h14M83 105c0 7-6 9-12 9l11 12"
        stroke="#002662"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />

      {/* arrow up on left (reward -> thumbs) */}
      <path
        d="M55 114H32V70"
        stroke="#002662"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M24 78l8-9 8 9"
        stroke="#002662"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}


function RefereeIllustration() {
  return (
<svg xmlns="http://www.w3.org/2000/svg" className='absolute right-2 bottom-4 sm:h-16 sm:w-16 md:right-7 md:bottom-3 opacity-[0.9]' width="135" height="135" viewBox="0 0 135 135" fill="none">
<g clipPath="url(#clip0_1503_917)">
<path d="M76.2012 89.1211C76.7337 89.4423 77.2606 89.7728 77.7832 90.1098C80.6062 91.8804 83.504 93.0853 86.748 93.8671C86.9897 93.927 87.2314 93.9868 87.4804 94.0484C94.9662 95.595 102.27 93.5823 108.633 89.6484C108.905 89.4496 109.178 89.2507 109.459 89.0459C110.215 88.5937 110.215 88.5937 110.789 88.5803C115.231 90.1152 119.698 92.7492 122.871 96.2402C123.181 96.542 123.181 96.542 123.497 96.8499C123.726 97.0838 123.954 97.3176 124.189 97.5586C124.36 97.7299 124.53 97.9012 124.705 98.0777C128.188 101.737 130.504 106.323 131.918 111.138C132.014 111.461 132.014 111.461 132.112 111.791C134.171 119.221 133.154 127.659 133.154 135C110.183 135 87.2121 135 63.5449 135C63.5449 126.908 63.5449 118.816 63.5449 110.478C60.4125 110.478 57.2801 110.478 54.0527 110.478C54.3748 108.868 54.9723 107.493 55.6348 105.996C55.7429 105.745 55.8509 105.494 55.9623 105.235C59.5019 97.5588 66.4063 92.0046 74.0918 88.8574C75.0766 88.5291 75.2844 88.6787 76.2012 89.1211Z" fill="#FFC107" fillOpacity="0.3"/>
<path d="M105.46 34.4349C109.786 37.8627 112.491 42.5321 113.379 47.9883C113.517 49.6037 113.497 51.2267 113.493 52.8466C113.494 53.3105 113.496 53.7743 113.497 54.2381C113.5 55.2054 113.499 56.1727 113.497 57.14C113.493 58.3677 113.499 59.5952 113.507 60.8228C113.511 61.7795 113.511 62.7362 113.51 63.693C113.51 64.145 113.511 64.5971 113.515 65.0491C113.538 68.7923 113.142 72.4125 111.335 75.7727C111.245 75.9466 111.155 76.1204 111.061 76.2995C110.245 77.8202 109.271 79.146 108.105 80.4199C107.95 80.5997 107.794 80.7795 107.634 80.9648C104.236 84.6587 99.1584 86.8202 94.1999 87.0962C88.4157 87.2913 83.1591 85.6923 78.8379 81.7383C78.5682 81.5048 78.5682 81.5048 78.293 81.2666C74.5238 77.7998 72.3602 72.5403 71.9824 67.5C71.9419 66.1556 71.9388 64.8115 71.9381 63.4666C71.9373 63.0763 71.9364 62.6859 71.9355 62.2955C71.9339 61.4799 71.9334 60.6644 71.9336 59.8489C71.9336 58.8133 71.93 57.7777 71.9254 56.7421C71.9225 55.9363 71.922 55.1305 71.9221 54.3247C71.9218 53.9433 71.9207 53.562 71.9186 53.1807C71.8864 46.6196 73.3925 41.1746 78.0469 36.3867C78.1985 36.2188 78.35 36.0509 78.5062 35.8779C85.4439 28.4091 97.676 28.7572 105.46 34.4349Z" fill="#FFC107" fillOpacity="0.3"/>
<path d="M16.3477 70.9277C17.2926 71.3091 17.6847 71.7545 18.2335 72.6035C18.3919 72.8452 18.5503 73.0868 18.7135 73.3358C18.8845 73.6016 19.0554 73.8674 19.2316 74.1412C19.5115 74.5689 19.7914 74.9966 20.0718 75.4239C20.2716 75.7284 20.4712 76.033 20.6704 76.3379C21.7728 78.0219 22.9041 79.686 24.0361 81.3502C25.9051 84.0987 27.7661 86.8525 29.6136 89.6155C29.7934 89.8835 29.9733 90.1515 30.1585 90.4276C30.3203 90.6701 30.4821 90.9126 30.6488 91.1625C30.7903 91.3742 30.9318 91.5859 31.0776 91.804C31.377 92.2852 31.377 92.2852 31.377 92.5488C29.2887 92.5488 27.2004 92.5488 25.0488 92.5488C25.0715 94.7723 25.0962 96.9957 25.1246 99.2192C25.1378 100.252 25.15 101.284 25.1601 102.317C25.1699 103.316 25.1821 104.314 25.196 105.312C25.2008 105.691 25.2048 106.071 25.2079 106.45C25.2358 109.749 25.296 112.946 27.6485 115.491C29.7779 117.46 31.8841 117.895 34.7355 117.915C34.9646 117.918 35.1936 117.921 35.4297 117.923C36.1843 117.932 36.939 117.938 37.6937 117.945C38.218 117.95 38.7422 117.956 39.2665 117.961C40.6445 117.976 42.0225 117.989 43.4005 118.002C45.0548 118.017 46.7092 118.035 48.3635 118.052C50.8751 118.078 53.3868 118.101 55.8984 118.125C55.8984 123.694 55.8984 129.263 55.8984 135C49.5637 135.042 49.5637 135.042 46.8383 135.051C44.9874 135.058 43.1366 135.065 41.2857 135.08C39.7915 135.091 38.2973 135.097 36.803 135.1C36.2364 135.102 35.6697 135.106 35.1031 135.112C27.6728 135.184 21.2315 133.333 15.7637 128.079C11.0421 123.417 8.14662 117.371 8.05409 110.688C8.05043 109.843 8.05979 108.998 8.07083 108.153C8.07281 107.699 8.0743 107.244 8.07535 106.79C8.07932 105.612 8.08963 104.434 8.10141 103.256C8.11233 102.046 8.11704 100.837 8.12233 99.6278C8.13354 97.2681 8.15204 94.9085 8.17383 92.5488C6.08555 92.5488 3.99727 92.5488 1.8457 92.5488C2.55029 91.3158 3.24382 90.1617 4.03851 88.9944C4.20025 88.7562 4.20025 88.7562 4.36527 88.5132C4.71679 87.9958 5.06927 87.479 5.42175 86.9623C5.6688 86.5991 5.91577 86.2358 6.16269 85.8725C6.67032 85.1258 7.17829 84.3792 7.68652 83.6329C8.39723 82.5889 9.10622 81.5438 9.81457 80.4982C11.9812 77.3004 14.1518 74.1056 16.3477 70.9277Z" fill="#FFC107" fillOpacity="0.3"/>
<path d="M29.5848 48.4064C29.7412 48.5295 29.8975 48.6525 30.0586 48.7793C30.253 48.9241 30.4474 49.0689 30.6477 49.2181C30.9761 49.474 30.9761 49.474 31.311 49.7351C36.7009 53.6634 43.1702 55.2507 49.7753 54.2587C54.2059 53.493 58.409 51.6523 61.7404 48.6196C62.4902 48.2519 62.4902 48.2519 63.0249 48.3891C63.212 48.4668 63.399 48.5444 63.5918 48.6245C63.7808 48.7012 63.9698 48.7779 64.1646 48.857C64.3081 48.9184 64.4517 48.9797 64.5996 49.043C64.5984 49.2687 64.5973 49.4945 64.5961 49.7271C64.5854 51.8716 64.5774 54.0161 64.5723 56.1607C64.5696 57.2628 64.5659 58.3649 64.5598 59.4669C64.554 60.5338 64.5509 61.6006 64.5496 62.6674C64.5486 63.0711 64.5467 63.4748 64.5439 63.8785C64.4999 70.3066 65.8419 75.7719 69.0295 81.4107C69.3457 82.0019 69.3457 82.0019 69.6094 82.793C69.3415 82.9208 69.0737 83.0486 68.7978 83.1802C68.431 83.3586 68.0644 83.5372 67.6978 83.7158C67.5231 83.7987 67.3484 83.8817 67.1684 83.9671C66.3017 84.3923 65.5227 84.7907 64.7808 85.4178C62.2215 87.5021 59.6325 87.3387 56.4639 87.3289C55.9066 87.333 55.3493 87.3376 54.792 87.3426C53.6291 87.3505 52.4665 87.3502 51.3036 87.3447C49.8172 87.3385 48.3322 87.3564 46.8461 87.3809C45.6971 87.3964 44.5484 87.3973 43.3994 87.394C42.8516 87.3946 42.3037 87.4001 41.756 87.4107C37.6084 87.4815 37.6084 87.4815 36.4574 86.7027C35.6 85.8733 35.0765 84.9101 34.541 83.8476C34.2652 83.4328 33.9848 83.021 33.6964 82.6148C33.4278 82.2078 33.1601 81.8003 32.8931 81.3922C32.5737 80.909 32.2541 80.4259 31.9342 79.943C31.6755 79.5526 31.6755 79.5526 31.4116 79.1542C30.3492 77.5593 29.2723 75.9743 28.1964 74.3884C27.9609 74.041 27.7253 73.6937 27.4898 73.3463C26.8871 72.4574 26.2841 71.5687 25.6811 70.6801C24.6926 69.223 23.7045 67.7658 22.7167 66.3083C22.2678 65.6462 21.8186 64.9842 21.3694 64.3223C21.0533 63.8554 20.7386 63.3876 20.4239 62.9197C19.9627 62.2354 19.4927 61.5579 19.0188 60.8824C18.7721 60.5257 18.5255 60.169 18.2789 59.8123C18.1609 59.6473 18.0429 59.4822 17.9213 59.3122C17.1303 58.1581 17.1303 58.1581 17.1722 57.408C18.7853 54.2204 22 51.9269 24.9829 50.1141C25.1415 50.0177 25.3001 49.9213 25.4635 49.822C28.4165 48.0957 28.4165 48.0957 29.5848 48.4064Z" fill="#FFC107" fillOpacity="0.3"/>
<path d="M45.7965 -0.131817C46.2093 -0.129841 46.2093 -0.129841 46.6304 -0.127826C51.4237 -0.0207506 55.1732 1.87842 58.5352 5.27346C62.0573 9.03378 63.1453 13.4137 63.1319 18.4292C63.1331 18.8301 63.1345 19.2309 63.1361 19.6317C63.1384 20.4678 63.1378 21.3039 63.1352 22.14C63.1322 23.2011 63.1375 24.2619 63.1452 25.3229C63.1501 26.1498 63.1499 26.9766 63.1484 27.8035C63.1484 28.1942 63.15 28.5849 63.1533 28.9755C63.1878 33.7219 61.9309 37.7785 58.7988 41.3965C58.6449 41.5756 58.4909 41.7547 58.3323 41.9393C55.2914 45.2234 50.9219 47.0338 46.4784 47.2148C41.3401 47.1106 37.1234 45.4557 33.3875 41.9568C29.8037 38.1391 28.6555 33.6358 28.6609 28.5631C28.6599 28.1599 28.6588 27.7567 28.6575 27.3535C28.6555 26.5104 28.6556 25.6674 28.657 24.8243C28.6585 23.7523 28.6541 22.6804 28.6479 21.6084C28.644 20.7759 28.6438 19.9434 28.6447 19.1109C28.6445 18.7161 28.6432 18.3213 28.6405 17.9265C28.6115 13.0587 29.7572 8.8591 33.1733 5.28929C36.6814 1.76748 40.7973 -0.163566 45.7965 -0.131817Z" fill="#FFC107" fillOpacity="0.3"/>
</g>
<defs>
<clipPath id="clip0_1503_917">
<rect width="135" height="135" fill="white"/>
</clipPath>
</defs>
</svg>
  );
}

function CheckIcon({ color }: { color: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none" 
      className="shrink-0 mt-0.5 sm:h-4 sm:w-4"
      aria-hidden="true"
    >
      <path
        d="M18.1675 10.3333C18.5481 12.2011 18.2768 14.1428 17.399 15.8348C16.5212 17.5268 15.0899 18.8667 13.3438 19.6311C11.5976 20.3955 9.64218 20.5381 7.80357 20.0353C5.96497 19.5325 4.35432 18.4145 3.24022 16.8678C2.12613 15.3212 1.57593 13.4394 1.68138 11.5361C1.78683 9.63294 2.54156 7.8234 3.8197 6.4093C5.09784 4.9952 6.82214 4.06202 8.70505 3.76537C10.5879 3.46872 12.5156 3.82654 14.1667 4.77916"
        stroke={color}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 11.1667L10 13.6667L18.3333 5.33337"
        stroke={color}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function CheckItem({
  text,
  iconColor,
  type,
}: {
  text: string;
  iconColor: string;
  type: 'referrer' | 'referee';
}) {
  const color = type === 'referrer' ? '#FFC107' : iconColor;
  return (
    <li className="flex items-start  gap-3 relative z-[2]">
      <CheckIcon color={color} />
      <div
        className="text-xs lg:text-[18px] sm:mt-0.5 leading-[1.45] text-[#343434] font-normal tracking-[-0.02em]"
        dangerouslySetInnerHTML={{ __html: text }}
      />
    </li>
  );
}


function splitList(value?: string | null): string[] | null {
  if (!value) return null;
  const liMatches = value.match(/<li[^>]*>([\s\S]*?)<\/li>/gi);
  if (liMatches && liMatches.length > 0) {
    const items = liMatches
      .map((li) => li.replace(/<\/?li[^>]*>/gi, '').trim())
      .filter(Boolean);
    if (items.length) return items;
  }

  if (/<p[\s>]/i.test(value)) {
    const items = value
      .split(/<\/p>\s*<p[^>]*>/i)
      .map((s) => s.replace(/<\/?p[^>]*>/gi, '').trim())
      .filter(Boolean);
    if (items.length) return items;
  }

  const plainItems = value.split('\n').map((s) => s.trim()).filter(Boolean);
  return plainItems.length ? plainItems : null;
}

export default function StepsSection({ data,programs }: { data?: ReferralData['ReferralBenefit'], programs?: any}) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const heading = data?.Heading;
  const subHeading = data?.SubHeading ;
  const benefitCards = data?.ReferralBenefitCard || [];
  const referrerTitle = benefitCards[0]?.Heading ;
  const referrerHeadingIcon = benefitCards[0]?.HeadingIcon ;
  const refereeTitle = benefitCards[1]?.Heading ;
  const refereeHeadingIcon = benefitCards[1]?.HeadingIcon ;
  const referrerList = splitList(benefitCards[0]?.Description)
  const refereeList = splitList(benefitCards[1]?.Description) ;

  return (
    <section className="overflow-hidden bg-[linear-gradient(90deg,#bfcbdf_0%,#F8F1D8_100%)] sm:py-8 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1440px] sm:px-3 px-6 md:px-10 xl:px-20">
        <div className="text-center">
          <h2 className="text-[#1E3A70] sm:text-start text-[26px] lg:text-[32px] leading-[1.08] font-bold tracking-[-0.03em] md:text-[52px]">
            {heading}
          </h2>

          <p className="mt-3 text-[#444444] sm:text-start text-xs lg:text-base leading-[1.4] font-normal md:mt-4 md:text-[22px]">
            {subHeading}
          </p>
        </div>

        <div className="mt-12 flex flex-col gap-8 lg:flex-row lg:items-stretch lg:gap-8">
          <div className="relative flex-1 overflow-hidden sm:rounded-2xl rounded-[34px] border-[2.5px] border-[#113D81] bg-[#F5F7FB] lg:p-6 sm:p-3 shadow-[0px_5px_18px_rgba(17,61,129,0.12)] md:px-10 md:py-9 lg:min-h-[260px]">
            <div className="relative z-[2] flex sm:mb-2 items-center gap-5">
              <div className="flex lg:h-[62px] w-8 h-8 lg:w-[62px] items-center justify-center rounded-full bg-[#223B74]">
                <img
                  src={referrerHeadingIcon ? mediaUrl(referrerHeadingIcon) : '/referral/referrer-icon.png'}
                  alt="Referrer"
                  className="h-[8vh] w-[8vw] object-contain"
                />
              </div>

              <h3 className="text-[#223B74] text-base lg:text-[34px] font-bold tracking-[-0.03em] md:text-[42px]">
                {referrerTitle}
              </h3>
            </div>

            <ul className="relative z-[2] lg:mt-4 sm:space-y-2 space-y-5 max-w-[620px]">
              {referrerList?.map((item) => (
                <CheckItem key={item} text={item} iconColor="#223B74" type="referrer" />
              ))}
            </ul>

            <ReferrerIllustration />
          </div>

          <div className="relative flex-1 overflow-hidden sm:rounded-2xl rounded-[34px] border-[2.5px] border-[#E6B200] bg-[#FCF8EC] p-6 sm:px-3 sm:py-4 shadow-[0px_5px_18px_rgba(230,178,0,0.12)] md:px-10 md:py-9 lg:min-h-[260px]">
            <div className="relative z-[2] sm:mb-2 flex items-center gap-5">
              <div className="flex w-8 h-8 lg:h-[62px] lg:w-[62px] items-center justify-center rounded-full bg-[#FFC400]">
               <img src={refereeHeadingIcon ? mediaUrl(refereeHeadingIcon) : '/referral/referee-icon.png'}
                  alt="Referee"
                  className="h-[5vh] w-[5vw] object-contain"
                />
              </div>

              <h3 className="text-[#223B74] sm:text-base lg:text-[34px] font-bold tracking-[-0.03em] md:text-[42px]">
                {refereeTitle}
              </h3>
            </div>

            <ul className="relative z-[2] lg:mt-4 sm:space-y-2 space-y-5 max-w-[620px]">
              {refereeList?.map((item) => (
                <CheckItem key={item} text={item} iconColor="#F2B400" type="referee" />
              ))}
            </ul>

            <RefereeIllustration />
          </div>
        </div>

        <div className="mt-8 flex justify-center md:mt-12 sm:justify-start">
          <button
            type="button"
            onClick={() => setIsModalOpen(true)}
            className="inline-flex items-center justify-center gap-4 rounded-[20px] bg-[#223B74] sm:rounded-2xl sm:py-2 px-8 py-4 text-base font-bold text-white shadow-[0px_10px_24px_rgba(34,59,116,0.24)] transition-all duration-300 hover:translate-y-[-2px] hover:bg-[#1A2F5F] md:px-5 md:py-3 md:text-[26px] md:min-w-[300px]"
          >
            Refer Now

            <svg width="30" height="30" viewBox="0 0 30 30" fill="none">
              <path
                d="M7 15H23"
                stroke="white"
                strokeWidth="2.5"
                strokeLinecap="round"
              />
              <path
                d="M16 8L23 15L16 22"
                stroke="white"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>

      {isModalOpen && <ReferralModal programs={programs} onClose={() => setIsModalOpen(false)} />}
    </section>
  );
}
